import React, { useId } from 'react';
import SearchSelect, { SearchItem } from './SearchSelect';
import './ItemQuantityField.css';

interface Props {
  items: SearchItem[];
  value: string;
  onChange: (id: string) => void;
  quantity: string;
  onQuantityChange: (quantity: string) => void;
  label: string;
  ariaLabel?: string;
  quantityLabel?: string;
  unit?: string;
  placeholder?: string;
  min?: number;
  step?: number | 'any';
  disabled?: boolean;
  quantityInputType?: 'number' | 'text';
  quantityInputMode?: 'decimal' | 'numeric' | 'text';
  quantityDisabled?: boolean;
  quantityRequired?: boolean;
  appearance?: 'default' | 'outlined';
  itemInput?: React.ReactNode;
}

export default function ItemQuantityField({
  items, value, onChange, quantity, onQuantityChange, label, ariaLabel = label,
  quantityLabel = 'Кількість', unit, placeholder = 'Пошук позиції…', min = 0.001, step = 0.001, disabled = false,
  quantityInputType = 'number', quantityInputMode = 'decimal', quantityDisabled = false, quantityRequired = true,
  appearance = 'default',
  itemInput,
}: Props) {
  const id = useId();
  return <div className={`crm-item-quantity${appearance === 'outlined' ? ' crm-item-quantity--outlined' : ''}`}>
    <div className="crm-item-quantity__item">
      <span className="crm-item-quantity__label" aria-hidden="true">{label}</span>
      {itemInput ?? <SearchSelect items={items} value={value} onChange={onChange} placeholder={placeholder}
        minWidth={0} variant="order" ariaLabel={ariaLabel} disabled={disabled} />}
    </div>
    <div className="crm-item-quantity__amount">
      <label className="crm-item-quantity__label" htmlFor={id}>{quantityLabel}</label>
      <div className="crm-item-quantity__quantity-pill">
        <input id={id} type={quantityInputType} inputMode={quantityInputMode}
          {...(quantityInputType === 'number' ? { min, step } : {})}
          required={quantityRequired}
          aria-label={`${quantityLabel}: ${ariaLabel}`} value={quantity} disabled={disabled || quantityDisabled}
          onChange={event => onQuantityChange(event.target.value)} placeholder="0" />
        {unit && <span className="crm-item-quantity__unit">{unit}</span>}
      </div>
    </div>
  </div>;
}
